import React from 'react';
import { Calendar, CreditCard, RefreshCw } from 'lucide-react';

const TransactionDetails = ({ subscription, planAmount, paymentMethod }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString)?.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const billingIntervalLabel = subscription?.billingInterval === 'yearly' ? 'year' : 'month';

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-6">
      <h2 className="text-xl font-semibold text-gray-900 mb-4">Transaction Details</h2>
      <div className="space-y-4">
        {/* Plan & Amount */}
        <div className="flex justify-between items-center pb-4 border-b border-gray-200">
          <div>
            <p className="text-sm text-gray-600">Plan</p>
            <p className="text-lg font-semibold text-gray-900">{subscription?.plan?.name}</p>
          </div>
          <div className="text-right">
            <p className="text-sm text-gray-600">Amount Paid</p>
            <p className="text-2xl font-bold text-gray-900">£{planAmount}</p>
            <p className="text-xs text-gray-500">per {billingIntervalLabel}</p>
          </div>
        </div>

        {/* Payment Method */}
        <div className="flex items-start">
          <CreditCard className="w-5 h-5 text-gray-400 mr-3 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-medium text-gray-900">Payment Method</p>
            <p className="text-sm text-gray-600">{paymentMethod || 'Card ending in ****'}</p>
          </div>
        </div>

        {/* Billing Period */}
        <div className="flex items-start">
          <Calendar className="w-5 h-5 text-gray-400 mr-3 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-medium text-gray-900">Current Billing Period</p>
            <p className="text-sm text-gray-600">
              {formatDate(subscription?.currentPeriodStart)} - {formatDate(subscription?.currentPeriodEnd)}
            </p>
          </div>
        </div>

        {/* Next Renewal */}
        <div className="flex items-start">
          <RefreshCw className="w-5 h-5 text-gray-400 mr-3 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-medium text-gray-900">Next Renewal Date</p>
            <p className="text-sm text-gray-600">
              {formatDate(subscription?.currentPeriodEnd)}
            </p>
            {subscription?.cancelAtPeriodEnd ? (
              <p className="text-xs text-orange-600 mt-1">
                Subscription will not renew (cancelled)
              </p>
            ) : (
              <p className="text-xs text-gray-500 mt-1">
                You'll be charged £{planAmount} on this date
              </p>
            )}
          </div>
        </div>

        {/* Transaction Date */}
        <div className="pt-4 border-t border-gray-200">
          <div className="flex justify-between text-sm">
            <span className="text-gray-600">Transaction Date</span>
            <span className="text-gray-900 font-medium">{formatDate(new Date()?.toISOString())}</span>
          </div>
          <div className="flex justify-between text-sm mt-2">
            <span className="text-gray-600">Status</span>
            <span className="text-green-600 font-medium">✓ Completed</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionDetails;